<template>
  <div>
    <notifications group="components-notify" position="top right">
      <template slot="body" slot-scope="props">
        <div :class="['vue-notification', props.item.type]">
          <p>{{ props.item.title }}</p>
        </div>
      </template>
    </notifications>
    <div class="category-products-form">
      <h1 class="mb-3">{{ title }}</h1>
      <p v-if="isCreate && parentCategory" class="mb-3 text-muted">
        Родитель: <strong>{{ parentCategory.name }}</strong>
      </p>
      <div class="mb-3">
        <label for="category">Название категории</label>
        <va-input id="category" v-model="form.name" class="mb-0" />
        <div
          v-if="!$v.form.name.required && $v.form.name.$error"
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="mb-3">
        <label for="h1">h1</label>
        <va-input id="h1" v-model="form.h1" class="mb-0" />
      </div>
      <div class="mb-3">
        <label for="slug">slug</label>
        <va-input 
          id="slug" 
          v-model="form.slug" 
          class="mb-0"
          placeholder="Автоматически генерируется из названия"
          @input="slugManuallyEdited = true"
        />
        <div class="text-muted" style="font-size: 0.85rem; margin-top: 4px;">
          Оставьте пустым для автоматической генерации из названия
        </div>
      </div>
      <div class="mb-3">
        <label for="meta_title">meta_title</label>
        <va-input
          id="meta_title"
          v-model="form.meta_title"
          class="mb-0"
        />
        <div
          v-if="
            !$v.form.meta_title.required &&
            $v.form.meta_title.$error
          "
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="mb-3">
        <label for="meta_description">meta_description</label>
        <va-input
          id="meta_description"
          v-model="form.meta_description"
          class="mb-0"
        />
        <div
          v-if="
            !$v.form.meta_description.required &&
            $v.form.meta_description.$error
          "
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="mb-3">
        <label for="description">description (HTML)</label>
        <va-input
          id="description"
          v-model="form.description"
          type="textarea"
          class="mb-0"
          :min-rows="4"
        />
      </div>
      <div class="mb-3">
        <label for="file-upload" class="custom-file-upload">
          Загрузить фотографию
        </label>
        <input
          id="file-upload"
          ref="fileInput"
          type="file"
          class="file-input"
          accept="image/x-png,image/jpg,image/jpeg"
          @input="onFilePicked($event)"
        />
      </div>
      <div class="mb-3">
        <div v-if="form.photo && !imageData">
          <img
            class="category-img"
            :src="form.photo"
            alt="category-img"
          />
          <span
            ><va-button small @click.prevent="removeImg">
              Удалить</va-button
            ></span
          >
        </div>
        <div v-if="imageData">
          <img class="category-img" :src="imageData" alt="category-img" />
          <div>
            <span
              ><va-button small @click.prevent="removeImg">
                Удалить</va-button
              ></span
            >
          </div>
        </div>
      </div>

      <div class="mb-3">
        <va-checkbox
          v-model="form.is_hidden"
          label="Скрыть из публичной части сайта"
        />
      </div>

      <div class="mb-3 category-products-block">
        <label>Товары в категории</label>
        <va-input
          v-model="productSearch"
          placeholder="Поиск товаров по названию..."
          class="mb-2"
          @input="onProductSearchInput"
        />
        <div
          v-if="searchResults.length > 0"
          class="category-products-search-results"
        >
          <div
            v-for="p in searchResults"
            :key="p.id"
            class="category-products-search-item"
          >
            <span>{{ p.name }}</span>
            <va-button
              small
              color="info"
              :disabled="isProductSelected(p.id)"
              @click="addProduct(p)"
            >
              {{ isProductSelected(p.id) ? "Добавлен" : "Добавить" }}
            </va-button>
          </div>
        </div>
        <div
          v-if="selectedProducts.length > 0"
          class="category-products-selected mt-2"
        >
          <div class="category-products-selected-label">Выбранные товары:</div>
          <ul class="category-products-list">
            <li
              v-for="p in selectedProducts"
              :key="p.id"
              class="category-products-list-item"
            >
              <label class="category-products-list-label">
                <input
                  type="checkbox"
                  :checked="p.checked"
                  class="category-products-list-checkbox"
                  @change="toggleProductChecked(p.id)"
                />
                <span>{{ p.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div class="mt-4">
        <va-button color="danger" @click.prevent="$emit('close')">
          Отменить
        </va-button>
        <va-button color="info" @click="submitForm">Сохранить</va-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions, mapMutations } from "vuex";
import { required } from "vuelidate/lib/validators";
var slugify = require("slugify");
export default {
  name: "CategoryForm",
  props: {
    mode: {
      type: String,
      default: "create",
      validator: (v) => v === "create" || v === "edit",
    },
    category: {
      type: Object,
      default: null,
    },
    parentId: {
      type: Number,
      default: null,
    },
    parentCategory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: this.getInitialForm(),
      selectedFile: null,
      imageData: null,
      productSearch: "",
      searchResults: [],
      selectedProducts: [],
      searchDebounceTimer: null,
      slugManuallyEdited: false, // Флаг для отслеживания ручного редактирования slug
    };
  },
  computed: {
    isCreate() {
      return this.mode === "create";
    },
    isEdit() {
      return this.mode === "edit";
    },
    title() {
      if (this.isEdit) return "Изменить категорию";
      return this.parentId
        ? "Добавить дочернюю категорию"
        : "Добавить категорию";
    },
  },
  watch: {
    category: {
      immediate: true,
      handler(newVal) {
        if (this.isEdit && newVal && newVal.slug) {
          this.loadCategoryWithProducts();
        } else if (this.isCreate) {
          this.resetCreateForm();
        }
      },
    },
    parentId() {
      if (this.isCreate) this.resetCreateForm();
    },
    // Автоматическая генерация slug из name при создании, если slug не был изменен вручную
    'form.name'(newVal) {
      if (this.isCreate && newVal && !this.slugManuallyEdited && (!this.form.slug || this.form.slug === '')) {
        this.form.slug = slugify(newVal, { lower: true });
      }
    },
  },
  validations: {
    form: {
      name: { required },
      meta_title: { required },
      meta_description: { required },
    },
  },
  methods: {
    ...mapActions({
      getCategories: "categories/getCategories",
    }),
    ...mapMutations(["SET_GLOBAL_LOADER"]),
    getInitialForm() {
      if (this.mode === "edit" && this.category && this.category.slug) {
        return {
          name: this.category.name || "",
          h1: this.category.h1 || "",
          meta_title: this.category.meta_title || "",
          meta_description: this.category.meta_description || "",
          description: this.category.description || "",
          is_hidden: this.category.is_hidden || false,
          slug: this.category.slug,
          photo: this.category.photo || null,
        };
      }
      return {
        name: "",
        h1: "",
        meta_title: "",
        meta_description: "",
        description: "",
        is_hidden: false,
        slug: "",
        photo: null,
      };
    },
    async submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) return false;

      this.SET_GLOBAL_LOADER(true);
      // Используем slug из формы, если он указан, иначе генерируем из name
      const slug = this.form.slug && this.form.slug.trim()
        ? slugify(this.form.slug.trim(), { lower: true })
        : slugify(this.form.name || this.form.h1 || '', { lower: true });
      const requiredData = {
        slug,
        name: this.form.name,
        h1: this.form.h1 || "",
        meta_title: this.form.meta_title,
        meta_description: this.form.meta_description,
        description: this.form.description || "",
        is_hidden: this.form.is_hidden || false,
      };
      requiredData.product_ids = this.selectedProducts
        .filter((p) => p.checked)
        .map((p) => p.id);

      if (this.selectedFile) {
        const formData = new FormData();
        formData.append("file", this.selectedFile, this.selectedFile.name);
        try {
          const res = await api.post("/upload-file", formData);
          const uploaded = res && res.data;
          const photoId = Array.isArray(uploaded)
            ? (uploaded[0] && uploaded[0].id)
            : (uploaded && uploaded.id);
          if (photoId) requiredData.photo_id = photoId;
        } catch (e) {
          this.SET_GLOBAL_LOADER(false);
          return;
        }
      }

      try {
        if (this.isCreate) {
          if (this.parentId != null) requiredData.parent_id = this.parentId;
          await api.post("/admin/categories", requiredData);
        } else {
          // URL должен содержать текущий slug категории (из БД), а не новый из формы —
          // иначе при смене slug запрос идёт на несуществующий URL и возвращает NOT_FOUND
          await api.put(
            `/admin/categories/${this.category.slug}`,
            requiredData
          );
        }
        this.$emit("close");
        await this.getCategories();
      } catch (error) {
        const errorData = error?.response?.data;
        const errors = errorData?.errors || {};
        const errorMessage = errorData?.message || errorData?.error || 'Не удалось сохранить категорию';
        
        // Показываем общее сообщение об ошибке
        this.$notify({
          group: 'components-notify',
          title: errorMessage,
          type: 'error',
          duration: 5000,
        });
        
        // Показываем конкретные ошибки валидации для каждого поля
        if (errors.slug) {
          const slugErrors = Array.isArray(errors.slug) ? errors.slug : [errors.slug];
          slugErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Slug: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
        if (errors.name) {
          const nameErrors = Array.isArray(errors.name) ? errors.name : [errors.name];
          nameErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Название: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
        if (errors.meta_title) {
          const metaTitleErrors = Array.isArray(errors.meta_title) ? errors.meta_title : [errors.meta_title];
          metaTitleErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Meta title: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
        if (errors.meta_description) {
          const metaDescErrors = Array.isArray(errors.meta_description) ? errors.meta_description : [errors.meta_description];
          metaDescErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Meta description: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
        if (errors.parent_id) {
          const parentErrors = Array.isArray(errors.parent_id) ? errors.parent_id : [errors.parent_id];
          parentErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Родительская категория: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
        if (errors.photo_id) {
          const photoErrors = Array.isArray(errors.photo_id) ? errors.photo_id : [errors.photo_id];
          photoErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Фото: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
        if (errors.product_ids) {
          const productErrors = Array.isArray(errors.product_ids) ? errors.product_ids : [errors.product_ids];
          productErrors.forEach(msg => {
            this.$notify({
              group: 'components-notify',
              title: `Товары: ${msg}`,
              type: 'error',
              duration: 5000,
            });
          });
        }
      } finally {
        this.SET_GLOBAL_LOADER(false);
      }
    },
    onFilePicked(event) {
      if (this.isEdit && this.form.photo && !this.imageData) {
        this.$notify({
          group: "components-notify",
          title: "Чтобы изменить фото удалите текущий",
          type: "error",
          duration: 5000,
        });
        this.$refs.fileInput.value = "";
        return;
      }
      const file = event.target.files && event.target.files[0];
      if (file) {
        this.selectedFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removeImg() {
      this.form.photo = null;
      this.imageData = null;
      this.selectedFile = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
    async loadCategoryWithProducts() {
      if (!this.category || !this.category.slug) return;
      try {
        const res = await api.get(`/admin/categories/${this.category.slug}`);
        const data = res.data.data || res.data;
        if (data) {
          this.form = {
            ...this.form,
            name: data.name ?? this.form.name,
            h1: data.h1 ?? this.form.h1 ?? "",
            meta_title: data.meta_title ?? this.form.meta_title,
            meta_description: data.meta_description ?? this.form.meta_description,
            description: data.description ?? this.form.description ?? "",
            is_hidden: data.is_hidden ?? false,
            slug: data.slug ?? this.form.slug,
            photo: data.photo ?? this.form.photo,
          };
          // При редактировании считаем, что slug уже установлен и не нужно его автоматически генерировать
          this.slugManuallyEdited = true;
          const products = data.products || [];
          this.selectedProducts = products.map((p) => ({
            id: p.id,
            name: p.name || p.title || "",
            checked: true,
          }));
        }
      } catch (e) {
        this.selectedProducts = [];
      }
    },
    onProductSearchInput() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.searchProducts();
      }, 300);
    },
    async searchProducts() {
      const q = this.productSearch.trim();
      if (!q) {
        this.searchResults = [];
        return;
      }
      try {
        const res = await api.get("/admin/products", {
          params: { query: q, per_page: 20, page: 1 },
        });
        const data = res.data.data || res.data;
        this.searchResults = Array.isArray(data)
          ? data
          : (data && data.data) || [];
      } catch (e) {
        this.searchResults = [];
      }
    },
    addProduct(p) {
      if (this.isProductSelected(p.id)) return;
      this.selectedProducts.push({
        id: p.id,
        name: p.name,
        checked: true,
      });
    },
    toggleProductChecked(id) {
      const p = this.selectedProducts.find((pr) => pr.id === id);
      if (p) p.checked = !p.checked;
    },
    isProductSelected(id) {
      return this.selectedProducts.some((pr) => pr.id === id);
    },
    resetCreateForm() {
      this.form = this.getInitialForm();
      this.selectedFile = null;
      this.imageData = null;
      this.selectedProducts = [];
      this.searchResults = [];
      this.productSearch = "";
      this.slugManuallyEdited = false;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
  },
};
</script>

<style scoped>
.category-products-form {
  width: 900px;
}
.text-muted {
  color: #6c757d;
  font-size: 0.95rem;
}
.category-img {
  width: 150px;
  height: auto;
  display: block;
}
.category-products-block label {
  display: block;
  margin-bottom: 0.5rem;
}
.category-products-search-results {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 4px;
}
.category-products-search-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.category-products-search-item:last-child {
  border-bottom: none;
}
.category-products-selected-label {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 6px;
}
.category-products-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  max-height: 500px;
  overflow-y: auto;
}
.category-products-list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.category-products-list-item:last-child {
  border-bottom: none;
}
.category-products-list-label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  margin: 0;
  font-weight: normal;
}
.category-products-list-label:hover {
  background: rgba(0, 0, 0, 0.03);
}
.category-products-list-checkbox {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  cursor: pointer;
}
</style>
